import { createReducer, on } from '@ngrx/store';
import {
  checkEmailAvailability,
  checkEmailAvailabilitySuccess,
  checkEmailAvailabilityFailure,
} from './register.actions';
import { initialRegisterState, RegisterState } from './register.selectors';

export const registerReducer = createReducer<RegisterState>(
  initialRegisterState,

  on(checkEmailAvailability, state => ({
    ...state,
    checking: true,
    available: null,
    error: null,
  })),

  on(checkEmailAvailabilitySuccess, (state, { available }) => ({
    ...state,
    checking: false,
    available,
  })),

  on(checkEmailAvailabilityFailure, (state, { error }) => ({
    ...state,
    checking: false,
    error,
  }))
);